"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var router_1 = require("@angular/router");
var core_2 = require("@ngx-translate/core");
var flex_layout_1 = require("@angular/flex-layout");
var material_module_1 = require("../material.module");
var shell_component_1 = require("./shell/shell.component");
var route_reusable_strategy_1 = require("./route-reusable-strategy");
var authentication_service_1 = require("./authentication/authentication.service");
var authentication_guard_1 = require("./authentication/authentication.guard");
var i18n_service_1 = require("./i18n.service");
var http_1 = require("@angular/common/http");
var authentication_interceptor_1 = require("./authentication/authentication.interceptor");
var CoreModule = /** @class */ (function () {
    function CoreModule(parentModule) {
        // Import guard
        if (parentModule) {
            throw new Error(parentModule + " has already been loaded. Import Core module in the AppModule only.");
        }
    }
    CoreModule = tslib_1.__decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                http_1.HttpClientModule,
                core_2.TranslateModule,
                flex_layout_1.FlexLayoutModule,
                material_module_1.MaterialModule,
                router_1.RouterModule
            ],
            declarations: [
                shell_component_1.ShellComponent
            ],
            providers: [
                authentication_service_1.AuthenticationService,
                authentication_guard_1.AuthenticationGuard,
                {
                    provide: http_1.HTTP_INTERCEPTORS,
                    useClass: authentication_interceptor_1.AuthInterceptor,
                    multi: true
                },
                i18n_service_1.I18nService,
                {
                    provide: router_1.RouteReuseStrategy,
                    useClass: route_reusable_strategy_1.RouteReusableStrategy
                }
            ]
        }),
        tslib_1.__param(0, core_1.Optional()), tslib_1.__param(0, core_1.SkipSelf()),
        tslib_1.__metadata("design:paramtypes", [CoreModule])
    ], CoreModule);
    return CoreModule;
}());
exports.CoreModule = CoreModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29yZS5tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb3JlLm1vZHVsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxzQ0FBNkQ7QUFDN0QsMENBQStDO0FBQy9DLDBDQUFtRTtBQUNuRSw0Q0FBc0Q7QUFDdEQsb0RBQXdEO0FBRXhELHNEQUFvRDtBQUNwRCwyREFBeUQ7QUFDekQscUVBQWtFO0FBQ2xFLGtGQUFnRjtBQUNoRiw4RUFBNEU7QUFDNUUsK0NBQTZDO0FBQzdDLDZDQUEyRTtBQUMzRSwwRkFBOEU7QUE2QjlFO0lBRUksb0JBQW9DLFlBQXdCO1FBQ3hELGVBQWU7UUFDZixJQUFJLFlBQVksRUFBRTtZQUNkLE1BQU0sSUFBSSxLQUFLLENBQUksWUFBWSx3RUFBcUUsQ0FBQyxDQUFDO1NBQ3pHO0lBQ0wsQ0FBQztJQVBRLFVBQVU7UUEzQnRCLGVBQVEsQ0FBQztZQUNOLE9BQU8sRUFBRTtnQkFDTCxxQkFBWTtnQkFDWix1QkFBZ0I7Z0JBQ2hCLHNCQUFlO2dCQUNmLDhCQUFnQjtnQkFDaEIsZ0NBQWM7Z0JBQ2QscUJBQVk7YUFDZjtZQUNELFlBQVksRUFBRTtnQkFDVixnQ0FBYzthQUNqQjtZQUNELFNBQVMsRUFBRTtnQkFDUCw4Q0FBcUI7Z0JBQ3JCLDBDQUFtQjtnQkFDbkI7b0JBQ0ksT0FBTyxFQUFFLHdCQUFpQjtvQkFDMUIsUUFBUSxFQUFFLDRDQUFlO29CQUN6QixLQUFLLEVBQUUsSUFBSTtpQkFDZDtnQkFDRCwwQkFBVztnQkFDWDtvQkFDSSxPQUFPLEVBQUUsMkJBQWtCO29CQUMzQixRQUFRLEVBQUUsK0NBQXFCO2lCQUNsQzthQUNKO1NBQ0osQ0FBQztRQUdlLG1CQUFBLGVBQVEsRUFBRSxDQUFBLEVBQUUsbUJBQUEsZUFBUSxFQUFFLENBQUE7aURBQWUsVUFBVTtPQUZuRCxVQUFVLENBU3RCO0lBQUQsaUJBQUM7Q0FBQSxBQVRELElBU0M7QUFUWSxnQ0FBVSJ9


//////////////////
// WEBPACK FOOTER
// ./src/app/core/core.module.ts
// module id = 132
// module chunks = 0